import { useIntl } from "react-intl";
import DashboardClientLayout from "../../Layouts/DashboardClientLayout";
import "./HomePage.css";

function ChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

function SettingsSlidersIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 7h7M15 7h5M8 7v0m0 0a2 2 0 1 0 0 4m0-4v4M4 17h11M19 17h1M15 17v0m0 0a2 2 0 1 0 0 4m0-4v4" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="3" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
  );
}

function RouteIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 6h4a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H8a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h10" />
      <path d="M15 18l3-3-3-3" />
    </svg>
  );
}

function CardIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="M4 10h16" />
    </svg>
  );
}

function GlobeIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c2.4 2.3 3.6 5.1 3.6 8.5S14.4 18.7 12 21M12 3.5C9.6 5.8 8.4 8.6 8.4 12s1.2 6.2 3.6 8.5" />
    </svg>
  );
}

function CurrencyIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.8v8.4M9.6 9.2c.5-1 1.4-1.6 2.4-1.6 1.3 0 2.5.8 2.5 2.1 0 1.2-.9 1.8-2.1 2.1l-1 .2c-1.2.3-2.1.9-2.1 2 0 1.4 1.2 2.2 2.7 2.2 1.1 0 2-.4 2.7-1.1" />
    </svg>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 4a5 5 0 0 0-5 5v2.5c0 .9-.3 2.1-.8 3l-.9 1.5h13.4l-.9-1.5c-.5-.9-.8-2.1-.8-3V9a5 5 0 0 0-5-5Z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="m5.5 8.5 6.5 5 6.5-5" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="5" width="16" height="15" rx="2.5" />
      <path d="M8 3.5v3M16 3.5v3M4 10h16" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="10" width="14" height="10" rx="2.5" />
      <path d="M8 10V7.8A4 4 0 0 1 12 4a4 4 0 0 1 4 3.8V10" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.5 19 6.4v5.2c0 4.4-3 7.8-7 9.4-4-1.6-7-5-7-9.4V6.4L12 3.5Z" />
      <path d="m8.5 12.1 2.4 2.4 4.8-5" />
    </svg>
  );
}

function InfoIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 10.5v5M12 8.2v.3" />
    </svg>
  );
}

function HelpIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 15.2v.3M9.8 9.8a2.5 2.5 0 1 1 4.4 1.7c-.9.8-1.8 1.2-1.8 2.5" />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10 4.5H6.8A2.3 2.3 0 0 0 4.5 6.8v10.4a2.3 2.3 0 0 0 2.3 2.3H10" />
      <path d="m13 8 4 4-4 4M17 12H9" />
    </svg>
  );
}

function SectionRow({ icon, title, desc, trailing, isStatus = false }) {
  const Icon = icon;
  return (
    <div className="ps-row">
      <span className="ps-row-icon">
        <Icon />
      </span>
      <div className="ps-row-copy">
        <strong>{title}</strong>
        <small>{desc}</small>
      </div>
      {trailing ? (
        <span className={isStatus ? "ps-row-trailing is-status" : "ps-row-trailing"}>
          {trailing}
        </span>
      ) : null}
      <span className="ps-row-chevron" aria-hidden="true">
        <ChevronIcon />
      </span>
    </div>
  );
}

function SelectPill({ value }) {
  return (
    <button type="button" className="ps-select-pill">
      <span>{value}</span>
      <ChevronIcon />
    </button>
  );
}

function Toggle({ checked }) {
  return (
    <span className={`ps-toggle ${checked ? "is-on" : "is-off"}`} aria-hidden="true">
      <span />
    </span>
  );
}

function ToggleRow({ icon, title, desc, checked }) {
  const Icon = icon;
  return (
    <div className="ps-toggle-row">
      <span className="ps-row-icon">
        <Icon />
      </span>
      <div className="ps-row-copy">
        <strong>{title}</strong>
        <small>{desc}</small>
      </div>
      <Toggle checked={checked} />
    </div>
  );
}

export default function SettingsClient() {
  const intl = useIntl();

  return (
    <>
      <div className="ps-hero">
        <h1>{intl.formatMessage({ id: "dashboard.settings.page.title" })}</h1>
        <p>{intl.formatMessage({ id: "dashboard.settings.page.subtitle" })}</p>
      </div>

      <div className="ps-layout">
        <section className="ps-main">
          <article className="ps-card">
            <div className="ps-card-head">
              <SettingsSlidersIcon />
              <h2>{intl.formatMessage({ id: "dashboard.settings.general.title" })}</h2>
            </div>

            <div className="ps-rows">
              <SectionRow
                icon={UserIcon}
                title={intl.formatMessage({ id: "dashboard.settings.general.accountInfo.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.general.accountInfo.desc" })}
              />
              <SectionRow
                icon={RouteIcon}
                title={intl.formatMessage({ id: "dashboard.settings.general.ridePrefs.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.general.ridePrefs.desc" })}
              />
              <SectionRow
                icon={CardIcon}
                title={intl.formatMessage({ id: "dashboard.settings.general.paymentMethods.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.general.paymentMethods.desc" })}
              />
              <div className="ps-row ps-row-select">
                <span className="ps-row-icon">
                  <GlobeIcon />
                </span>
                <div className="ps-row-copy">
                  <strong>{intl.formatMessage({ id: "dashboard.settings.general.language.title" })}</strong>
                  <small>{intl.formatMessage({ id: "dashboard.settings.general.language.desc" })}</small>
                </div>
                <SelectPill value={intl.formatMessage({ id: "dashboard.settings.general.language.value" })} />
              </div>
              <div className="ps-row ps-row-select">
                <span className="ps-row-icon">
                  <CurrencyIcon />
                </span>
                <div className="ps-row-copy">
                  <strong>{intl.formatMessage({ id: "dashboard.settings.general.currency.title" })}</strong>
                  <small>{intl.formatMessage({ id: "dashboard.settings.general.currency.desc" })}</small>
                </div>
                <SelectPill value={intl.formatMessage({ id: "dashboard.settings.general.currency.value" })} />
              </div>
            </div>
          </article>

          <article className="ps-card">
            <div className="ps-card-head">
              <BellIcon />
              <h2>{intl.formatMessage({ id: "dashboard.settings.notifications.title" })}</h2>
            </div>

            <div className="ps-rows">
              <ToggleRow
                icon={BellIcon}
                title={intl.formatMessage({ id: "dashboard.settings.notifications.push.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.notifications.push.desc" })}
                checked
              />
              <ToggleRow
                icon={MailIcon}
                title={intl.formatMessage({ id: "dashboard.settings.notifications.promoEmails.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.notifications.promoEmails.desc" })}
                checked
              />
              <ToggleRow
                icon={CalendarIcon}
                title={intl.formatMessage({ id: "dashboard.settings.notifications.dailySummary.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.notifications.dailySummary.desc" })}
                checked={false}
              />
              <ToggleRow
                icon={BellIcon}
                title={intl.formatMessage({ id: "dashboard.settings.notifications.rideAlerts.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.notifications.rideAlerts.desc" })}
                checked
              />
            </div>
          </article>
        </section>

        <aside className="ps-sidebar">
          <article className="ps-card ps-side-card">
            <div className="ps-card-head">
              <ShieldIcon />
              <h2>{intl.formatMessage({ id: "dashboard.settings.security.title" })}</h2>
            </div>
            <div className="ps-rows">
              <SectionRow
                icon={LockIcon}
                title={intl.formatMessage({ id: "dashboard.settings.security.password.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.security.password.desc" })}
              />
              <SectionRow
                icon={ShieldIcon}
                title={intl.formatMessage({ id: "dashboard.settings.security.twoFactor.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.security.twoFactor.desc" })}
                trailing={intl.formatMessage({ id: "dashboard.settings.security.twoFactor.status" })}
                isStatus
              />
              <SectionRow
                icon={InfoIcon}
                title={intl.formatMessage({ id: "dashboard.settings.security.activeSessions.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.security.activeSessions.desc" })}
              />
            </div>
          </article>

          <article className="ps-card ps-side-card">
            <div className="ps-card-head">
              <ShieldIcon />
              <h2>{intl.formatMessage({ id: "dashboard.settings.privacy.title" })}</h2>
            </div>
            <div className="ps-rows">
              <SectionRow
                icon={UserIcon}
                title={intl.formatMessage({ id: "dashboard.settings.privacy.personalData.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.privacy.personalData.desc" })}
              />
              <SectionRow
                icon={ShieldIcon}
                title={intl.formatMessage({ id: "dashboard.settings.privacy.permissions.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.privacy.permissions.desc" })}
              />
              <SectionRow
                icon={CalendarIcon}
                title={intl.formatMessage({ id: "dashboard.settings.privacy.activityHistory.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.privacy.activityHistory.desc" })}
              />
            </div>
          </article>

          <article className="ps-card ps-side-card">
            <div className="ps-card-head">
              <HelpIcon />
              <h2>{intl.formatMessage({ id: "dashboard.settings.other.title" })}</h2>
            </div>
            <div className="ps-rows">
              <SectionRow
                icon={HelpIcon}
                title={intl.formatMessage({ id: "dashboard.settings.other.helpCenter.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.other.helpCenter.desc" })}
              />
              <SectionRow
                icon={InfoIcon}
                title={intl.formatMessage({ id: "dashboard.settings.other.terms.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.other.terms.desc" })}
              />
              <SectionRow
                icon={InfoIcon}
                title={intl.formatMessage({ id: "dashboard.settings.other.about.title" })}
                desc={intl.formatMessage({ id: "dashboard.settings.other.about.desc" })}
              />
            </div>
            <button type="button" className="ps-logout-btn">
              <LogoutIcon />
              <span>{intl.formatMessage({ id: "dashboard.settings.other.logout" })}</span>
            </button>
          </article>
        </aside>
      </div>
    </>
  );
}